import { render, staticRenderFns } from "./TodoPagination.vue?vue&type=template&id=2e3a763e&scoped=true&"
import script from "./TodoPagination.vue?vue&type=script&lang=js&"
export * from "./TodoPagination.vue?vue&type=script&lang=js&"
import style0 from "./TodoPagination.vue?vue&type=style&index=0&id=2e3a763e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3a763e",
  null
  
)

export default component.exports